export default "__VITE_PUBLIC_ASSET__c3be0888__"